import { IUserFull } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

/**
 * Resolves a single organization user from their email address, used to turn a
 * stored email (such as `manager_email`) into a displayable user.
 *
 * The lookup is an exact, case-insensitive match, so it returns at most one
 * user — and `null` when the email belongs to nobody in the organization.
 */
export function useUserByEmail(email?: string) {
  const { api } = useTacticHooks();

  return useQuery({
    queryKey: ["organizations.usersPaginated", { email }],
    enabled: Boolean(email),
    queryFn: async (): Promise<IUserFull | null> => {
      if (!email) {
        return null;
      }

      const res = await api.client.organizations.usersPaginated(
        new URLSearchParams({ email })
      );

      return res.result?.elements?.[0] ?? null;
    }
  });
}
